module.exports = __webpack_public_path__ + "img/about2.bacd96a5.jpg";